export default __webpack_public_path__ + "static/ReactGraphQL-Academy_logo@2x-a78743d4a75c904b56c3b1a921b94705.png";